import { render, staticRenderFns } from "./UsuarioDetalle.vue?vue&type=template&id=d4ed1b40&scoped=true&"
import script from "./UsuarioDetalle.vue?vue&type=script&lang=js&"
export * from "./UsuarioDetalle.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioDetalle.vue?vue&type=style&index=0&id=d4ed1b40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ed1b40",
  null
  
)

export default component.exports